import React, { useEffect, useState } from "react"
import { Container, Table, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { Row, Form } from "reactstrap"
import Select from "react-select"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Loader from "pages/Separate/Loader"
import ReactSelect from "react-select"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import {
    colourStyles,
    developmentProjectType,
    ResourceType,
} from "utils/common-options"
import { fetchNodeData, FetchNodePostData, FetchPostData } from "utils/common-fetchData"

const DevProjects = ({ stageData, getFetchStep }) => {
    const token = secureLocalStorage.getItem("auth_token")
    const userId = localStorage.getItem("auth_id")
    const [isLoading, setLoading] = useState(false)
    const [fixButtons, setFixButtons] = useState(false)
    // All Options
    const [locationOption, setLocationOption] = useState([])
    const [customerOptions, setCustomerOptions] = useState([])
    const [allKeyIndustryOption, setAllKeyIndustryOption] = useState([])
    const [detailsFromCred2, setDetailsFromCred2] = useState(null)
    const [allZtplCredOption, setAllZtplCredOption] = useState([])
    const [all192CredOption, setAll192CredOption] = useState([])
    const [sourceOption, setSourceOption] = useState([])
    const [projectReferenceOptions, setProjectReferenceOptions] = useState([])
    const [projectKeyManagerOptions, setProjectKeyManagerOptions] = useState([])
    const [projectScrumOptions, setProjectScrumOptions] = useState([])
    const [projectMembersOptions, setProjectMembersOptions] = useState([])
    const [projectFromGitOption, setProjectFromGitOption] = useState([])
    const [contractOption, setContractOption] = useState([])

    // Hours Allocation
    const [kamHours, setKamHours] = useState(0)
    const [frontHours, setFrontHours] = useState(0)
    const [endHours, setEndHours] = useState(0)
    const [testHours, setTestHours] = useState(0)
    const [deployHours, setDeployHours] = useState(0)
    const [totalHours, setTotalHours] = useState(0)
    const toggleLoading = loading => {
        setLoading(loading)
    }

    // Basic Details
    const [location, setLocation] = useState([])
    const [projectName, setProjectName] = useState("")
    const [projectType, setProjectType] = useState([])
    const [projectSource, setProjectSource] = useState([])
    const [projectReference, setProjectReference] = useState([])
    const [projectResourceType, setProjectResourceType] = useState([])
    const [projectCustomer, setProjectCustomer] = useState([])
    const [projectIndustry, setProjectIndustry] = useState([])
    const [projectDescription, setProjectDescription] = useState("")
    const [contract, setContract] = useState([])

    // Member variables
    const [projectKeyManager, setProjectKeyManager] = useState([])
    const [projectScrumMaster, setProjectScrumMaster] = useState([])
    const [startDate, setStartDate] = useState("")
    const [projectEstDays, setProjectEstDays] = useState("")
    const [endDate, setEndDate] = useState("")
    const [deliveryDate, setDeliveryDate] = useState("")
    const [projectMembers, setProjectMembers] = useState([])
    const [projectTotalHours, setProjectTotalHours] = useState("")
    const [hoursPerWeek, setHoursPerWeek] = useState("")

    // Server Details
    const [serverFolderName, setServerFolderName] = useState("")
    const [server192Link, setServer192Link] = useState("")
    const [serverZTPLLink, setServerZTPLLink] = useState("")

    // Git Details
    const [custType, setCustType] = useState("")
    const [gitProject, setGitProject] = useState("New")
    const [projectFromGit, setProjectFromGit] = useState([])
    const [projectFromGitName, setProjectFromGitName] = useState("")
    const [gitRepositoryLink, setGitRepositoryLink] = useState("")
    const [gitDemoLink, setGitDemoLink] = useState("")
    const [gitIcodeLink, setGitIcodeLink] = useState("")

    // ZTPL details
    const [detailsFromCred, setDetailsFromCred] = useState("")
    const [ztplDetails, setZtplDetails] = useState("New")
    const [zhost, setZhost] = useState("ftp.ztpl.net")
    const [zusername, setZusername] = useState("")
    const [zpassword, setZpassword] = useState("")
    const [zdatabasename, setZdatabasename] = useState("")
    const [zdbusername, setZdbusername] = useState("")
    const [zdbpassword, setZdbpassword] = useState("")

    // 192 Details
    const [localServer, setLocalServer] = useState("New")
    const [host, setHost] = useState("192.168.0.2")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [databasename, setDatabasename] = useState("")
    const [dbusername, setDbusername] = useState("")
    const [dbpassword, setDbpassword] = useState("")

    const SumTotalHours =
        Number(kamHours) +
        Number(frontHours) +
        Number(endHours) +
        Number(testHours) +
        Number(deployHours)
    const isValid = totalHours >= SumTotalHours
    document.title = "Add Project | Zithas Crm"

    document.addEventListener("scroll", () => {
        if (window.scrollY > 360) {
            setFixButtons(true)
        } else {
            setFixButtons(false)
        }
    })


    useEffect(() => {
        if (startDate && projectEstDays) {
            setEndDate(calculateEndDate(startDate, projectEstDays))
        } else {
            setEndDate("")
        }
    }, [startDate, projectEstDays])

    function calculateEndDate(startDate, totalHours) {
        const WORK_HOURS_PER_DAY = 8
        const totalBusinessDays = Math.ceil(totalHours / WORK_HOURS_PER_DAY)
        const resultDate = new Date(startDate)

        let remainingDays = totalBusinessDays

        while (remainingDays > 0) {
            resultDate.setDate(resultDate.getDate() + 1)
            const dayOfWeek = resultDate.getDay()

            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                // It's a business day
                remainingDays--
            }
        }

        return resultDate.toISOString().split("T")[0]
    }

    const fetchProjectData = async () => {
        const res = await fetchNodeData(toggleLoading, "projectRelatedData", token)
        if (res?.success) {
            const { data } = res
            const {
                location,
                source,
                customer,
                introducer,
                industry,
                keymanager,
                scrum,
                projects,
                ztpl,
                data_192,
                developers,
                contract,
            } = data
            const createOptions = (items, label, value) =>
                items?.map(item => ({ label: item?.[label], value: item?.[value] }))

            setLocationOption(createOptions(location, "location", "id"))
            setSourceOption(
                source?.map(obj => ({
                    value: obj?.id,
                    label: obj?.leadname,
                    customerOption: createOptions(customer, "company", "id"),
                    introducerOption: createOptions(introducer, "company", "id"),
                    ...obj
                }))
            )
            setCustomerOptions(createOptions(customer, "company", "id"))
            setProjectCustomer(createOptions(customer, "company", "id")?.find((obj) => obj?.value == stageData?.customer_id))
            setAllKeyIndustryOption(createOptions(industry, "name", "id"))
            setProjectKeyManagerOptions(createOptions(keymanager, "name", "id"))
            setProjectScrumOptions(createOptions(scrum, "name", "id"))
            setProjectFromGitOption(createOptions(projects, "project_name", "id"))
            setAllZtplCredOption(createOptions(ztpl, "Project", "id"))
            setAll192CredOption(createOptions(data_192, "Project", "id"))
            setProjectMembersOptions(createOptions(developers, "name", "id"))
            setContractOption(
                contract?.map(obj => ({
                    value: obj?.id,
                    label: `${obj?.id}-${obj?.company_name}-${obj?.service}`,
                }))
            )

            if (stageData?.stage >= 3 && stageData?.project_type == 1) {
                const res = await fetchNodeData(
                    toggleLoading,
                    `projectView/${stageData?.project_id}`,
                    token
                )
                if (res?.success) {
                    const projectDetails = res?.data?.project[0]
                    console.log(projectDetails)
                    setLocationOption(createOptions(location, "location", "id"))
                    const sources = source?.map(obj => ({
                        value: obj?.id,
                        label: obj?.leadname,
                        customerOption: createOptions(customer, "company", "id"),
                        introducerOption: createOptions(introducer, "company", "id"),
                        ...obj,
                    }))
                    setSourceOption(sources)
                    setKamHours(projectDetails?.planning)
                    setFrontHours(projectDetails?.designing)
                    setEndHours(projectDetails?.development)
                    setTestHours(projectDetails?.testing)
                    setDeployHours(projectDetails?.deployment)
                    setCustomerOptions(createOptions(customer, "company", "id"))
                    setAllKeyIndustryOption(createOptions(industry, "name", "id"))
                    setProjectKeyManagerOptions(createOptions(keymanager, "name", "id"))
                    setProjectScrumOptions(createOptions(scrum, "name", "id"))
                    setProjectMembersOptions(createOptions(developers, "name", "id"))
                    setProjectName(projectDetails?.project_name)
                    setLocation(
                        createOptions(location, "location", "id")?.find(
                            obj => obj?.value == projectDetails?.projectbelogsto
                        )
                    )
                    setProjectType(
                        developmentProjectType?.find(
                            obj => obj?.value == projectDetails?.project_type
                        )
                    )
                    const projecrSrc = sources?.find(
                        obj => obj?.value == projectDetails?.source
                    )
                    setProjectSource(projecrSrc)
                    const SourceRefer =
                        projecrSrc?.label?.toLowerCase() == "customer"
                            ? projecrSrc?.customerOption
                            : projecrSrc?.label?.toLowerCase() == "introducer"
                                ? projecrSrc?.introducerOption
                                : []
                    setProjectReferenceOptions(SourceRefer)
                    setProjectReference(
                        SourceRefer?.find(obj => obj?.value == projectDetails?.source_name)
                    )
                    setProjectResourceType(
                        ResourceType?.find(
                            obj => obj?.value == projectDetails?.billingtype
                        )
                    )
                    setProjectCustomer(
                        createOptions(customer, "company", "id")?.find(
                            obj => obj?.value == projectDetails?.customer
                        )
                    )
                    setProjectIndustry(
                        createOptions(industry, "name", "id")?.find(
                            obj => obj?.value == projectDetails?.industry
                        )
                    )
                    setProjectDescription(projectDetails?.description || "")
                    setProjectKeyManager(
                        createOptions(keymanager, "name", "id")?.find(
                            obj => obj?.value == projectDetails?.keyaccountmanager
                        )
                    )
                    setProjectScrumMaster(
                        createOptions(scrum, "name", "id")?.find(
                            obj => obj?.value == projectDetails?.scrum_master
                        )
                    )
                    setStartDate(projectDetails?.startdate)
                    setEndDate(projectDetails?.enddate)
                    setProjectEstDays(projectDetails?.no_of_weeks)
                    // setTotalHours(Number(projectDetails?.no_of_hours) * 5 * 7)
                    setTotalHours(projectDetails?.total_hrs)
                    setProjectTotalHours(projectDetails?.total_hrs)
                    setHoursPerWeek(projectDetails?.hrs_per_week)

                    setDeliveryDate(projectDetails?.deliverydatebefore)
                    setProjectMembers(
                        createOptions(developers, "name", "id")?.filter(obj =>
                            projectDetails?.member?.split(",")?.includes(obj?.value?.toString())
                        )
                    )
                    const contrat = contract?.map(obj => ({
                        value: obj?.id,
                        label: `${obj?.id}-${obj?.company_name}-${obj?.service}`,
                    }))
                    setContractOption(contrat)
                    setContract(
                        contrat?.find(obj => obj?.value == projectDetails?.contract_id)
                    )
                }
            }
        }
    }

    useEffect(() => {
        fetchProjectData()
    }, [])

    const onAddProject = async e => {
        e.preventDefault()

        const onAdd = async () => {
            if (
                location?.length != 0 &&
                projectType?.length != 0 &&
                projectResourceType?.length != 0 &&
                projectCustomer?.length != 0 &&
                projectIndustry?.length != 0 &&
                contract?.length != 0
            ) {
            }
            const formEntries = {
                user_id: userId,
                location: location?.value || "",
                project_name: projectName,
                project_type: projectType?.value || "",
                source: projectSource?.value || "",
                source_name: projectReference?.value || "",
                resource_type: projectResourceType?.value || "",
                customer: projectCustomer?.value || "",
                industry: projectIndustry?.value || "",
                description: projectDescription,
                contract_id: contract?.value || "",

                keyaccountmanager: projectKeyManager?.value || "",
                scrum_master: projectScrumMaster?.value || "",
                member: projectMembers?.map(obj => obj?.value)?.join(","),
                total_hrs: projectTotalHours,
                hour_per_week: hoursPerWeek,
                start_date: startDate,
                end_date: endDate,
                no_of_weeks: projectEstDays,
                deliverydatebefore: deliveryDate,

                folder_name: serverFolderName,
                ztpl_link: serverZTPLLink,
                link_192: server192Link,

                gitrepositorylink: gitRepositoryLink,
                demo_link: gitDemoLink,
                icode_link: gitIcodeLink,
                git_project_id: projectFromGit?.value || "",

                zhost: zhost,
                zusername: zusername,
                zpassword: zpassword,
                zdatabasename: zdatabasename,
                zdbusername: zdbusername,
                zdbpassword: zdbpassword,

                host: host,
                username: username,
                password: password,
                databasename: databasename,
                dbusername: dbusername,
                dbpassword: dbpassword,
                ztpl_details: ztplDetails,
                details_192: localServer,

                total_hrs: totalHours,
                planning: kamHours,
                designing: frontHours,
                development: endHours,
                testing: testHours,
                deployment: deployHours,
            }
            const res = await FetchPostData(
                toggleLoading,
                "add_project",
                token,
                formEntries
            )
            if (res?.data?.success) {
                Swal.fire({
                    icon: "success",
                    title: "Project Added successfully.",
                }).then(async () => {
                    const formEntries = {
                        id: stageData?.id,
                        stage: 3,
                        project_type: 1,
                        project_id: res?.data?.data?.project2[0]?.id
                    }
                    const response = await FetchNodePostData(setLoading, 'stageProcess', token, formEntries);
                    if (response?.data?.success) {
                        getFetchStep()
                    }
                })
            }
        }

        if (stageData?.stage >= 4) {
            Swal.fire({
                icon: 'warning',
                title: "Are You sure?",
                text: "Again you want to add New Project as you have already saved & moved to next step?",
                showCancelButton: true,
                confirmButtonText: 'Yes, Create it!',
                cancelButtonText: 'No, cancel!',
            }).then((isOkay) => {
                if (isOkay?.isConfirmed) {
                    onAdd()
                }
            })
        } else {
            onAdd()
        }
    }

    const calculatePercentage = (hours, totalHours) => {
        return totalHours > 0
            ? Math.floor((Number(hours) / Number(totalHours)) * 100)
            : 0
    }

    const isBlinking = (percentage, threshold) => percentage > threshold

    const handleHoursChange = (e, setHours, fields) => {
        const newHours = e.target.value
        setHours(newHours)

        const total = Object.values(fields).reduce(
            (acc, hours) => acc + Number(hours),
            0
        )
    }

    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <form onSubmit={onAddProject}>
                <Row className="bg-white py-4 shadow mb-3 px-2">
                    <div className="d-flex gap-2 justify-content-between">
                        <h5 className="mb-3">Project Basic Details</h5>
                        <div >
                            <button
                                className="btn ms-md-2 btn-save btn-label"
                            >
                                <i className="fas fa-save me-1 label-icon"></i> save
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2 mt-2 mb-3">
                        <label htmlFor="">
                            Project Belongs To <span className="text-danger">*</span>
                        </label>
                        <Select
                            placeholder="Project Belongs To"
                            className="basic-multi-select"
                            classNamePrefix=" select"
                            options={locationOption}
                            value={location}
                            onChange={e => setLocation(e)}
                        />
                    </div>

                    <div className="col-md-6 mt-2 mb-3">
                        <label htmlFor="">
                            Project Name <span className="text-danger">*</span>
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Enter Project Name"
                            className="form-control "
                            value={projectName}
                            onChange={e => setProjectName(e.target.value)}
                        />
                    </div>

                    <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">
                            Project Type <span className="text-danger">*</span>
                        </label>
                        <Select
                            placeholder="Select Project Type"
                            className="basic-multi-select"
                            classNamePrefix=" select"
                            options={developmentProjectType?.filter((obj) => obj?.value != 3)}
                            value={projectType}
                            onChange={selectedOption => setProjectType(selectedOption)}
                        />
                    </div>

                    <div className="col-md-12 mb-3 d-flex justify-content-start align-items-center gap-4">
                        <div className="col-md-3 mt-2 mb-3 mb-md-0">
                            <label htmlFor=""> Source</label>
                            <Select
                                placeholder="Select Source"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={sourceOption?.filter((obj) => obj?.location == location?.value)}
                                value={projectSource}
                                onChange={e => {
                                    setProjectSource(e)
                                    if (e.label?.toLowerCase() == "introducer") {
                                        setProjectReferenceOptions(e.introducerOption)
                                    } else if (e.label?.toLowerCase() == "customer") {
                                        setProjectReferenceOptions(e.customerOption)
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-3 mb-3 mt-2 mb-md-0">
                            <label htmlFor="">
                                Select {projectSource?.label || ""}
                            </label>
                            <Select
                                placeholder={`Select ${projectSource?.label || ""}`}
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={projectReferenceOptions}
                                value={projectReference}
                                onChange={selectedOption =>
                                    setProjectReference(selectedOption)
                                }
                            />
                        </div>
                        <div className="col-md-3 mt-2 mb-3 mb-md-0">
                            <label htmlFor="">
                                Resource Type <span className="text-danger">*</span>
                            </label>
                            <Select
                                placeholder="Select Resource Type"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={ResourceType}
                                value={projectResourceType}
                                onChange={selectedOption =>
                                    setProjectResourceType(selectedOption)
                                }
                            />
                        </div>
                    </div>

                    <div className="col-md-12 mb-3 d-flex justify-content-start align-items-center gap-4">
                        <div className="col-md-3 mb-3 mt-2 mb-md-0">
                            <label htmlFor="">
                                Customer <span className="text-danger">*</span>
                            </label>
                            <Select
                                placeholder="Select Customer"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={customerOptions}
                                value={projectCustomer}
                                isDisabled
                                onChange={selectedOption =>
                                    setProjectCustomer(selectedOption)
                                }
                            />
                        </div>

                        <div className="col-md-3 mt-2 mb-3 mb-md-0">
                            <label htmlFor="">
                                {" "}
                                Project Industry <span className="text-danger">*</span>
                            </label>
                            <Select
                                placeholder="Select Industry"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={allKeyIndustryOption}
                                value={projectIndustry}
                                onChange={selectedOption =>
                                    setProjectIndustry(selectedOption)
                                }
                            />
                        </div>
                        <div className="col-md-3 mt-2 mb-3 mb-md-0">
                            <label htmlFor="">
                                Select Contract <span className="text-danger">*</span>
                            </label>
                            <Select
                                placeholder="Select Contract"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={contractOption}
                                value={contract}
                                onChange={e => setContract(e)}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <label htmlFor="">Description</label>
                        <CKEditor
                            editor={ClassicEditor}
                            onChange={(event, editor) => {
                                const data = editor.getData()
                                setProjectDescription(data)
                            }}
                        />
                    </div>
                </Row>
                <Row className="px-0">
                    <div className="col-md-6 pe-md-4">
                        <Row className="bg-white px-2 py-4 shadow mb-3">
                            <h5 className="mb-3">Members</h5>
                            <div className="col-md-6 mt-2 mb-3">
                                <label htmlFor="">Key Account Manager</label>
                                <Select
                                    placeholder="Select Key Account Manager"
                                    className="basic-multi-select"
                                    classNamePrefix=" select"
                                    options={projectKeyManagerOptions}
                                    value={projectKeyManager}
                                    onChange={e => setProjectKeyManager(e)}
                                />
                            </div>
                            <div className="col-md-6 mt-2 mb-3">
                                <label htmlFor="">Scrum Master</label>
                                <Select
                                    placeholder="Select Scrum Master"
                                    className="basic-multi-select"
                                    classNamePrefix=" select"
                                    options={projectScrumOptions}
                                    value={projectScrumMaster}
                                    onChange={e => setProjectScrumMaster(e)}
                                />
                            </div>
                            {projectType?.value == 2 ? (
                                <>
                                    <div className="col-md-12 mt-2 mb-3">
                                        <label htmlFor="">Members</label>
                                        <ReactSelect
                                            placeholder="Select Members"
                                            className="basic-multi-select "
                                            classNamePrefix="select"
                                            options={projectMembersOptions}
                                            isMulti="true"
                                            closeMenuOnSelect={false}
                                            value={projectMembers}
                                            onChange={e => setProjectMembers(e)}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2 mb-3">
                                        <label htmlFor="">
                                            Total Hours<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            required
                                            type="number"
                                            placeholder="Enter Total Hours"
                                            className="form-control "
                                            value={projectTotalHours}
                                            onChange={e => setProjectTotalHours(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2 mb-3">
                                        <label htmlFor="">
                                            Hours per Week<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            required
                                            type="number"
                                            placeholder="Enter Total Hours"
                                            className="form-control "
                                            value={hoursPerWeek}
                                            onChange={e => setHoursPerWeek(e.target.value)}
                                        />
                                    </div>
                                </>
                            ) : null}

                            <h5 className="mb-3 mt-4">Estimatation</h5>
                            <div className="col-md-6 mt-2 mb-3">
                                <label htmlFor="">
                                    Start Date <span className="text-danger">*</span>
                                </label>
                                <input
                                    required
                                    type="date"
                                    className="form-control "
                                    value={startDate}
                                    onChange={e => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="col-md-6 mt-2 mb-3">
                                <label htmlFor="">
                                    Number Of Hours<span className="text-danger">*</span>
                                </label>
                                <input
                                    required
                                    type="number"
                                    placeholder="Enter Number Of Hours"
                                    className="form-control "
                                    value={projectEstDays}
                                    onChange={e => {
                                        setProjectEstDays(e.target.value)
                                        setTotalHours(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="col-md-6 mt-2 mb-3 pb-5">
                                <label htmlFor="">Estimated End Date</label>
                                <input
                                    disabled
                                    type="date"
                                    className="form-control "
                                    value={endDate}
                                    onChange={e => setEndDate(e.target.value)}
                                />
                            </div>
                            <div className="col-md-6 mt-2 mb-3 pb-5">
                                <label htmlFor="">
                                    Delivery Before Date
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    required
                                    type="date"
                                    className="form-control "
                                    value={deliveryDate}
                                    onChange={e => {
                                        const newDBDate = e.target.value
                                        if (
                                            endDate &&
                                            new Date(newDBDate) < new Date(endDate)
                                        ) {
                                            Swal.fire({
                                                icon: "warning",
                                                title: "Warning",
                                                text: "The Delivery Before Date cannot be before the Estimated End Date.",
                                            })
                                        } else {
                                            setDeliveryDate(newDBDate)
                                        }
                                    }}
                                />
                            </div>
                        </Row>
                    </div>

                    <div className="col-md-6 ps-md-3">
                        {projectType?.value != 2 ? (
                            <Row className="bg-white px-2 py-4 shadow mb-3">
                                <div className="d-flex justify-content-between">
                                    <h5 className="mb-3">Actual Hours Details</h5>
                                </div>
                                <div className="responsive-table">
                                    <Table
                                        className={`table table-bordered mb-0 mt-3 table-hover`}
                                    >
                                        <thead>
                                            <tr>
                                                <th>Allocation Name</th>
                                                <th>Approx %</th>
                                                <th>Hours</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="bg-light-purple">
                                                <td className="col-6">
                                                    <strong className="text-purple fs-5">
                                                        Total Hours
                                                    </strong>
                                                </td>
                                                <td className="col-1 text-center">100 %</td>
                                                <td className="col-2">
                                                    <div className={`${isValid ? "" : "blinking"}`}>
                                                        <input
                                                            required
                                                            type="number"
                                                            placeholder="Hours.."
                                                            className="form-control"
                                                            name="estimatedtime"
                                                            value={totalHours}
                                                            disabled
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            {[
                                                {
                                                    name: "Planning",
                                                    label: projectKeyManager?.label,
                                                    value: kamHours,
                                                    setValue: setKamHours,
                                                    threshold: 10,
                                                    key: "kamHours",
                                                },
                                                {
                                                    name: "Designing",
                                                    value: frontHours,
                                                    setValue: setFrontHours,
                                                    threshold: 50,
                                                    key: "frontHours",
                                                },
                                                {
                                                    name: "Development",
                                                    value: endHours,
                                                    setValue: setEndHours,
                                                    threshold: 70,
                                                    key: "endHours",
                                                },
                                                {
                                                    name: "Testing",
                                                    value: testHours,
                                                    setValue: setTestHours,
                                                    threshold: 25,
                                                    key: "testHours",
                                                },
                                                {
                                                    name: "Deployment",
                                                    value: deployHours,
                                                    setValue: setDeployHours,
                                                    threshold: 10,
                                                    key: "deployHours",
                                                },
                                            ].map(
                                                ({
                                                    name,
                                                    label,
                                                    value,
                                                    setValue,
                                                    threshold,
                                                    key,
                                                }) => {
                                                    const percentage = calculatePercentage(
                                                        value,
                                                        totalHours
                                                    )
                                                    return (
                                                        <tr
                                                            key={key}
                                                            className={
                                                                isBlinking(percentage, threshold)
                                                                    ? "blinking-background"
                                                                    : ""
                                                            }
                                                        >
                                                            <td className="col-6">
                                                                {name}
                                                                {label && ` (${label})`}
                                                            </td>
                                                            <td className="col-1 text-center">
                                                                {percentage} %
                                                            </td>
                                                            <td className="col-2">
                                                                <input
                                                                    required
                                                                    type="number"
                                                                    placeholder="Hours.."
                                                                    className="form-control"
                                                                    name="estimatedtime"
                                                                    value={value}
                                                                    onChange={e =>
                                                                        handleHoursChange(e, setValue, {
                                                                            kamHours,
                                                                            frontHours,
                                                                            endHours,
                                                                            testHours,
                                                                            deployHours,
                                                                        })
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Row>
                        ) : null}
                    </div>
                </Row>
            </form>
        </React.Fragment>
    )
}

export default DevProjects
